import { Table } from 'antd'
import styled from 'styled-components'

export const FiltersRow = styled(Table.Summary.Row)`
    & .actions-cell {
        position: sticky;
        z-index: 6;
        right: 12px !important;
        background: white;
    }

    .actions-cell:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: -1px;
        left: 0;
        width: 30px;
        transform: translateX(-100%);
        transition: box-shadow 0.3s;
    }
`
